<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <div class="main-statistics">
            <div class="statistics-header">
              <h3 class="title">
                <div class="item">
                  비정상 원인
                </div>
              </h3>
            </div>
            <div class="statistics-body">
              <div class="form">
                <div class="contain">
                  <div class="select">
                    <div class="formSelect" ref="select02">
                      <div class="formSelectList" @click="openSelect02">
                        <input type="text" v-model="locationName" placeholder="지역" readonly />
                      </div>
                      <div class="formSelectPopup select02">
                        <div class="formSelectPopup-container">
                          <div class="outer">
                            <div class="inner">
                              <div class="formSelectPopup-box">
                                <div class="formSelectPopup-zone">
                                  <div class="formSelectPopup-header">
                                    <input type="text" placeholder="지역을 선택하세요." />
                                  </div>
                                  <ul class="formSelectPopup-body">
                                    <li v-for="locations in locationArr" :key="locations.name">
                                      <label>
                                        <input type="radio" v-model="selectedLocation" :value="locations.code" v-on:change="confirmSelect02()"/>
                                        <input type="checkbox" />
                                        <i></i>
                                        <span>{{locations.name}}</span>
                                      </label>
                                    </li>
                                  </ul>
                                  <div class="formSelectPopup-footer">
                                    <button class="formSelectPopup-cancel">
                                      취소
                                    </button>
                                    <!-- 비활성(Attribute) : disabled -->
                                    <button class="formSelectPopup-confirm">
                                      확인
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="calendar">
                    <div class="formCalendar">
                      <div class="formCalendarList">
                        <date-picker
                          v-model="dateRange"
                          type="date" range
                          :format="'YYYY-MM-DD'"
                          :clearable="false"
                          @change="updateValues"
                        >
                          <template v-slot:footer="{ emit }">
                            <div style="text-align: left">
                              <button class="mx-btn mx-btn-text" @click="setSearchPeriod(1, emit)">
                                1개월
                              </button>
                              <button class="mx-btn mx-btn-text" @click="setSearchPeriod(3, emit)">
                                3개월
                              </button>
                              <button class="mx-btn mx-btn-text" @click="setSearchPeriod(6, emit)">
                                6개월
                              </button>
                            </div>
                          </template>
                        </date-picker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ul class="statistics">
                <li>
                  <div class="contain">
                    <div class="header">
                      {{this.locationName}}
                    </div>
                    <div class="body">
                      <div class="graph">
                        <Doughnut-Chart class="doughnutChart" v-if="doughnutChartLoaded" :chartData="doughnutChartData" :options="doughnutChartOptions" style="height: 100%;"></Doughnut-Chart>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="contain">
                    <div class="header">
                      골프장 별 불량 원인
                    </div>
                    <div class="body">
                      <div class="legendContainer" @click="horizontalBarChartLegendEvt" v-html="horizontalBarChartLegendHtml"></div>
                      <div class="graph">
                        <HorizontalBar-Chart
                          class="horizontalBarChartContainer"
                          v-if="horizontalBarChartLoaded"
                          :chartData="horizontalBarChartData"
                          :options="horizontalBarChartOptions"
                          style="height: 100%;"
                          @setLegend="setLegend"
                        />
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="statisticsData">
                <!-- 데이터 없을때(Class) : none -->
                <div class="body">
                  <div class="table thead">
                    <!-- 헤더 고정 활성(Class) : active / x축 스크롤 이동 값(Style) : x축 스크롤 이동한 값 만큼 margin-left 마이너스 값 -->
                    <div class="fixed" style="margin-left: -0px;">
                      <div class="excel" @click="downloadExcel">
                        다운로드
                      </div>
                      <div class="contain">
                        <table>
                          <colgroup>
                            <col />
                            <col />
                            <col />
                            <col />
                            <col />
                          </colgroup>
                          <thead>
                          <tr>
                            <th class="sort club_name" @click="headerSort('club_name')">
                              <div class="item">
                                클럽
                              </div>
                            </th>
                            <th class="sort aplAbnormal" @click="headerSort('aplAbnormal')">
                              <div class="item">
                                통신오류
                              </div>
                            </th>
                            <th class="sort angleAbnormal" @click="headerSort('angleAbnormal')">
                              <div class="item">
                                뒤집힘
                              </div>
                            </th>
                            <th class="sort pinAbnormal" @click="headerSort('pinAbnormal')">
                              <div class="item">
                                핀이탈
                              </div>
                            </th>
                            <th class="sort batteryOut" @click="headerSort('batteryOut')">
                              <div class="item">
                                방전
                              </div>
                            </th>
                          </tr>
                          </thead>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="table tbody">
                    <div class="contain">
                      <table>
                        <colgroup>
                          <col />
                          <col />
                          <col />
                          <col />
                          <col />
                        </colgroup>
                        <tbody>
                        <tr v-for="errorStat in locationErrorStats" :key="errorStat.ccode">
                          <td>
                            {{ errorStat.club_name }}
                          </td>
                          <td>
                            {{ errorStat.aplAbnormal }}
                          </td>
                          <td>
                            {{ errorStat.angleAbnormal }}
                          </td>
                          <td>
                            {{ errorStat.pinAbnormal }}
                          </td>
                          <td>
                            {{ errorStat.batteryOut }}
                          </td>
                        </tr>
                        </tbody>
                        <tbody class="none">
                        <tr>
                          <td colspan="5" class="read-only">
                            데이터가 없습니다.
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <footerLayout></footerLayout>
      <div class="formSelectPopup select02">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select02">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="검색어를 입력하세요." />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="locations in locationArr" :key="locations.name">
                      <label>
                        <input type="radio" v-model="selectedLocation" :value="locations.code" @change="confirmSelect02"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{locations.name}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'
import {ammService} from '../../router'

import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import DoughnutChart from '../../util/DoughnutChart'
import HorizontalBarChart from '../../util/HorizontalBarChart'

const exportExcel = () => import('../../util/excel')

export default {
  name: 'ST001',
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout,
    DatePicker,
    DoughnutChart,
    HorizontalBarChart
  },
  data () {
    return {
      sortColumn: '',
      sortType: '',
      dateRange: [new Date(new Date().setMonth(new Date().getMonth() - 3)), new Date()],
      sDate: '',
      eDate: '',
      doughnutChartLoaded: false,
      doughnutChartData: {
        labels: [],
        datasets: []
      },
      doughnutChartOptions: {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          datalabels: {
            color: 'white',
            font: {
              size: 18
            },
            display: function (context) {
              let dataset = context.dataset
              let sum = 0
              dataset.data.map(data => {
                sum += data
              })
              let value = dataset.data[context.dataIndex]
              let percentage = (value * 100 / sum).toFixed(0)
              return percentage > 3
            },
            formatter: (value, ctx) => {
              let sum = 0
              let dataArr = ctx.chart.data.datasets[0].data
              dataArr.map(data => {
                sum += data
              })
              let percentage = (value * 100 / sum).toFixed(0) + '%'
              return percentage
            }
          }
        }
      },
      horizontalBarChartLoaded: false,
      horizontalBarChartData: {
        labels: [],
        datasets: [
          {
            label: '통신 오류',
            data: [],
            backgroundColor: 'red'
          },
          {
            label: '시스템 장애',
            data: [],
            backgroundColor: 'yellow'
          },
          {
            label: '핀 위치 오류',
            data: [],
            backgroundColor: 'blue'
          },
          {
            label: '배터리 방전',
            data: [],
            backgroundColor: 'black'
          }
        ]
      },
      horizontalBarChartOptions: {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true
            }
          }],
          yAxes: [{
            stacked: true
          }]
        },
        maxBarThickness: 10,
        plugins: {
          datalabels: {
            color: 'white',
            font: {
              size: 14
            },
            display: function (context) {
              let dataset = context.dataset
              let value = dataset.data[context.dataIndex]
              return value > 0
            },
            formatter: Math.round
          }
        }
      },
      labelKeys: [
        {
          label: '통신오류',
          key: 'aplAbnormal'
        },
        {
          label: '뒤집힘',
          key: 'angleAbnormal'
        },
        {
          label: '핀이탈',
          key: 'pinAbnormal'
        },
        {
          label: '방전',
          key: 'batteryOut'
        }
      ],
      horizontalBarChartSortKey: 'sum',
      errorSummaryDataAll: {
        aplStatsError: [],
        clubInfoList: []
      },
      errorSummaryData: [],
      angleAbnormalSum: 0, // 시스템 장애
      aplAbnormalSum: 0, // 통신 오류
      batteryOutSum: 0, // 배터리 방전
      pinAbnormalSum: 0, // 핀 위치 오류
      selectedLocation: '0',
      locationArr: [
        {name: '전국', code: '0'},
        {name: '경기도/인천', code: '1'},
        {name: '충청북도', code: '10'},
        {name: '충청남도', code: '11'},
        {name: '전라도', code: '20'},
        {name: '경상북도', code: '30'},
        {name: '경상남도', code: '31'},
        {name: '강원도', code: '40'},
        {name: '제주도', code: '50'}
      ],
      horizontalBarChartLegendHtml: null,
      colors: [
        '#FFC90F',
        '#FF910F',
        '#FF0F0F',
        '#333333'
      ]
    }
  },
  created: function () {
    let fromDate = new Date().setMonth(new Date().getMonth() - 3)
    let toDate = new Date()
    this.sDate = moment(fromDate).format('YYYY-MM-DD')
    this.eDate = moment(toDate).format('YYYY-MM-DD')
  },
  mounted: function () {
    this.setData()
  },
  methods: {
    setData: function () {
      ammService.getStatisticsData(moment(this.dateRange[0]).format('YYYY-MM-DD'), moment(this.dateRange[1]).format('YYYY-MM-DD')).then(response => {
        this.errorSummaryData = []
        this.errorSummaryDataAll = response.data
        this.errorSummaryDataAll.aplStatsError = this.errorSummaryDataAll.aplStatsError.reduce((acc, curr) => {
          const {
            ccode,
            angleAbnormal,
            aplAbnormal,
            batteryOut,
            pinAbnormal
          } = curr
          const target = acc.find(stat => stat.ccode === ccode)
          if (target) {
            target.angleAbnormal += angleAbnormal
            target.aplAbnormal += aplAbnormal
            target.batteryOut += batteryOut
            target.pinAbnormal += pinAbnormal
          } else {
            acc.push({
              ccode,
              angleAbnormal,
              aplAbnormal,
              batteryOut,
              pinAbnormal
            })
          }
          return acc
        }, [])
        this.errorSummaryDataAll.clubInfoList.forEach(item => {
          const dataPath = this.errorSummaryDataAll.aplStatsError.find(it => it.ccode.toString() === item.ccode)
          if (!dataPath) return
          let sum = dataPath.aplAbnormal + dataPath.batteryOut + dataPath.angleAbnormal + dataPath.pinAbnormal
          this.errorSummaryData.push({...dataPath, ...item, sum})
        })
        this.errorSummaryData.sort(function (a, b) {
          return b.sum - a.sum
        })
        this.setChartData()
      }).catch(error => {
        console.log('getStatisticsData.err.===>', error)
      })
    },
    getCurrentCcodeParam: function () {
      let currentCcode = localStorage.getItem('currentCcode')
      if (currentCcode) {
        return `?ccode=${currentCcode}`
      } else {
        return ''
      }
    },
    setDoughnutChart: function () {
      this.doughnutChartLoaded = false
      this.angleAbnormalSum = 0
      this.aplAbnormalSum = 0
      this.batteryOutSum = 0
      this.pinAbnormalSum = 0
      this.locationErrorStats.forEach(item => {
        this.angleAbnormalSum += item.angleAbnormal
        this.aplAbnormalSum += item.aplAbnormal
        this.batteryOutSum += item.batteryOut
        this.pinAbnormalSum += item.pinAbnormal
      })
      this.doughnutChartData = {
        labels: ['통신오류', '뒤집힘', '핀이탈', '방전'],
        datasets: [{
          data: [this.aplAbnormalSum, this.angleAbnormalSum, this.pinAbnormalSum, this.batteryOutSum],
          backgroundColor: this.colors
        }]
      }
      this.doughnutChartLoaded = true
    },
    setHorizontalBarChart: function () {
      this.horizontalBarChartLoaded = false
      const top10 = this.locationErrorStats
        .map(el => el)
        .sort((a, b) => a.sum < b.sum ? 1 : a.sum > b.sum ? -1 : 0)
        .sort((a, b) => a[this.horizontalBarChartSortKey] < b[this.horizontalBarChartSortKey] ? 1 : a[this.horizontalBarChartSortKey] > b[this.horizontalBarChartSortKey] ? -1 : 0)
        .slice(0, 10)

      this.horizontalBarChartData = {
        labels: top10.map(el => el.club_name),
        datasets: this.labelKeys.map((el, i) => {
          return {
            label: el.label,
            data: top10.map(item => item[el.key]),
            backgroundColor: this.colors[i]
          }
        })
      }
      this.horizontalBarChartLoaded = true
    },
    setChartData: function () {
      this.setDoughnutChart()
      this.setHorizontalBarChart()
    },
    setSearchPeriod: function (months, emit) {
      let fromDate = new Date(new Date().setMonth(new Date().getMonth() - months))
      let toDate = new Date()
      this.sDate = moment(fromDate).format('YYYY-MM-DD')
      this.eDate = moment(toDate).format('YYYY-MM-DD')
      this.dateRange[0] = fromDate
      this.dateRange[1] = toDate
      emit(this.dateRange)
    },
    updateValues: function (dateRange) {
      this.sDate = moment(dateRange[0]).format('YYYY-MM-DD')
      this.eDate = moment(dateRange[1]).format('YYYY-MM-DD')
      this.setData()
    },
    headerSort: function (target) {
      if (document.querySelector('.statisticsData thead tr th.ascending') !== null) {
        document.querySelector('.statisticsData thead tr th.ascending').classList.remove('ascending')
      }
      if (document.querySelector('.statisticsData thead tr th.descending') !== null) {
        document.querySelector('.statisticsData thead tr th.descending').classList.remove('descending')
      }
      if (this.sortColumn === target) {
        if (this.sortType === 'asc') {
          this.sortType = 'desc'
          document.querySelector('.statisticsData thead tr th.' + target).classList.add('descending')
        } else {
          this.sortType = 'asc'
          document.querySelector('.statisticsData thead tr th.' + target).classList.add('ascending')
        }
      } else {
        document.querySelector('.statisticsData thead tr th.' + target).classList.add('ascending')
        this.sortColumn = target
        this.sortType = 'asc'
      }
    },
    confirmSelect02: function () {
      this.closeSelectAll()
      this.setChartData()
    },
    horizontalBarChartLegendEvt: function (e) {
      let target = e.target || e.srcElement
      if (target.nodeName === 'SPAN') target = target.parentElement
      if (target === e.currentTarget) return
      const index = [].indexOf.call(target.parentNode.children, target)
      this.horizontalBarChartSortKey = this.horizontalBarChartSortKey === this.labelKeys[index].key ? 'sum' : this.labelKeys[index].key
      this.setHorizontalBarChart()
      if (this.horizontalBarChartSortKey !== 'sum') {
        this.$nextTick(() => {
          document.querySelectorAll('.legendContainer li')[index].classList.add('strong')
        })
      }
    },
    setLegend: function (html) {
      this.horizontalBarChartLegendHtml = html
    },
    downloadExcel: async function () {
      const table = document.querySelector('.statisticsData')
      const Excel = await exportExcel()
      Excel.default(table, 'APL통계')
    }
  },
  computed: {
    locationName () {
      const targetLocation = this.locationArr.find(location => location.code === this.selectedLocation)
      if (!targetLocation) return ''
      return targetLocation.name
    },
    locationErrorStats () {
      return this.errorSummaryData
        .filter(item => this.selectedLocation === '0' || this.setRegionCode(item.ccode, item.region_code) === Number(this.selectedLocation))
        .sort(this.sortType === 'asc' ? this.ascSort : this.descSort)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/states/ST001.vue